import { types, Instance } from 'mobx-state-tree';
const { model, string, array, boolean, identifier, maybe, maybeNull, union, number } = types;
const CustomAttributeModel = model({
  label: string,
  type: maybeNull(string),
  name: maybe(string),
  options: array(string),
  value: maybeNull(union(string, array(string))),
});

export const LDAPUserModel = model('LDAPUserModel', {
  dn: string,
  uid: maybe(string),
  cn: string,
  base: maybe(string),
  sn: string,
  displayname: maybe(string),
  givenname: maybe(string),
  description: maybe(string),
  mail: identifier,
  l: maybe(string),
  st: maybe(string),
  postaladdress: maybe(string),
  roomnumber: maybe(string),
  telephonenumber: maybe(string),
  mobile: maybe(string),
  pager: maybe(string),
  facsimiletelephonenumber: maybe(string),
  labeleduri: maybe(string),
  preferredlanguage: maybe(string),
  userpassword: maybe(string),
  passwordMethod: maybe(string),
  homepostaladdress: maybe(string),
  homephone: maybe(string),
  o: maybe(string),
  ou: maybe(string),
  departmentnumber: maybe(string),
  employeenumber: maybe(string),
  employeetype: maybe(string),
  objectclass: array(string),
  manager: maybe(string),
  locked: maybe(boolean),
  notify: maybe(boolean),
  createtimestamp: maybeNull(string),
  modifytimestamp: maybeNull(string),
  appStatus: maybe(boolean),
  googleId: maybeNull(string),
  zoomId: maybeNull(string),
  githubId: maybeNull(string),
  microsoftId: maybeNull(string),
  reSyncProvider: array(string),
  isTwoFactorEnable: maybe(boolean),
  customAttribute: array(CustomAttributeModel),
  gitStatus: maybe(string),
  user_id: number,
  devices: array(string),
  end_date: maybeNull(string),
});

export type ILDAPUserModel = Instance<typeof LDAPUserModel>;

export const LDAPUsersModel = model('LDAPUsersModel', {
  google_id: maybeNull(string),
  zoom_id: maybeNull(string),
});

export type ILDAPUsersModel = Instance<typeof LDAPUsersModel>;

export const LDAPEndUserModel = model('LDAPEndUserModel', {
  mail: string,
  userpassword: string,
  name: string,
  domain: maybe(string),
});

export type ILDAPEndUserModel = Instance<typeof LDAPEndUserModel>;

export const LDAPViewEndUserModel = model('LDAPViewEndUserModel', {
  uid: maybe(string),
  cn: maybe(string),
  base: maybe(string),
  givenname: string,
  middleName: maybe(string),
  sn: string,
  mail: string,
  phone: maybe(string),
  department: maybe(string),
  role: maybe(string),
  group: maybe(string),
  status: maybe(string),
});
export const FilterateRouteModel = model('FilterateRouteModel', {
  route: string,
  filterString: string,
});
export type ILDAPViewEndUserModel = Instance<typeof LDAPViewEndUserModel>;
